<template>
	<div class="container">
		<img src="@/assets/img/logo.png" height="125px" width="125px" style="cursor: pointer; margin-right: 4rem" />

		<h1>Great! 👍</h1>
		<h3>Your account is now connected. Please log back in to continue scheduling interviews</h3>
		<md-button class="md-success" @click="login" style="margin-top: 4rem; margin-left: -4rem">Login</md-button>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {};
	},
	methods: {
		login() {
			this.$router.push({ name: 'Login' });
		},
	},
};
</script>
<style scoped>
.container {
	width: 100%;
	height: calc(100vh - 200px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.container > h1 {
	text-align: center;
}
</style>
